import { render } from "./UMTDetails.vue?vue&type=template&id=4caed974&scoped=true"
import script from "./UMTDetails.vue?vue&type=script&lang=js"
export * from "./UMTDetails.vue?vue&type=script&lang=js"

import "./UMTDetails.vue?vue&type=style&index=0&id=4caed974&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4caed974"]])

export default __exports__